// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3qGhH","header":"ClearentDisclaimer_header__Lk5fE","inner":"ClearentDisclaimer_inner__13b1P"};